import React from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TenantDangerZoneSection({
  tenantName,
  disabled,
  confirmOpen,
  onOpenConfirm,
  onCloseConfirm,
  onDelete,
}) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("tenantDanger.title", "Nebezpečná zóna")}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("tenantDanger.warning", "Táto akcia je nezvratná. Odstránením sa vymažú všetky dáta organizácie.")}
      </Typography>

      <Button color="error" variant="contained" onClick={onOpenConfirm} disabled={disabled}>
        {t("tenantDanger.actions.delete", "Odstrániť organizáciu")}
      </Button>

      <Dialog open={confirmOpen} onClose={disabled ? undefined : onCloseConfirm}>
        <DialogTitle>{t("tenantModal.confirmDelete.title", "Potvrdiť odstránenie")}</DialogTitle>
        <DialogContent dividers>
          <Typography>
            {t("tenantModal.confirmDelete.messagePrefix", "Naozaj chcete odstrániť organizáciu")} <b>{tenantName || "—"}</b>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseConfirm} disabled={disabled}>
            {t("tenantModal.actions.cancel", "Zrušiť")}
          </Button>
          <Button color="error" variant="contained" onClick={onDelete} disabled={disabled}>
            {t("tenantModal.actions.delete", "Odstrániť")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
